import {
  IntroContainer,
  Title,
  Description,
  FacesGrid,
  IntroPhoto,
} from './styled'
import { texts } from '../../locale'
import imgUrlM from './assets/NizameHecimovic.png'
import imgUrlL from './assets/NizameHecimovicL.png'

const Intro = () => {
  return (
    <IntroContainer>
      <IntroPhoto>
        <picture>
          <source media="(min-width:1024px)" srcSet={imgUrlM} />
          <source media="(min-width:1600px)" srcSet={imgUrlL} />
          <img src={imgUrlM} alt="Nizame Hećimović" />
        </picture>
      </IntroPhoto>
      <Title>{texts.title}</Title>
      <Description>{texts.description}</Description>
    </IntroContainer>
  )
}
export default Intro
